import { Card, Group, Text } from "@mantine/core";
import { IconTags } from "@tabler/icons-react";

interface LicenseTypeOverviewProps {
	total: number;
	active: number;
}

function LicenseTypeOverview({ total, active }: LicenseTypeOverviewProps) {
	return (
		<Card
			shadow="sm"
			padding="lg"
			radius="md"
			withBorder
			mb="lg">
			<Group
				justify="space-between"
				mb="md">
				<Group>
					<IconTags size={20} />
					<Text fw={500}>License Type Overview</Text>
				</Group>
			</Group>
			<Group>
				<div>
					<Text
						size="xl"
						fw={700}>
						{total}
					</Text>
					<Text
						size="sm"
						c="dimmed">
						Total Types
					</Text>
				</div>
				<div>
					<Text
						size="xl"
						fw={700}
						c="green">
						{active}
					</Text>
					<Text
						size="sm"
						c="dimmed">
						Offered on New Licenses
					</Text>
				</div>
			</Group>
		</Card>
	);
}

export default LicenseTypeOverview;
